<template>
  <v-container>
    <h1>Gebruikersbeheer</h1>
    <div v-if="!gebruiker">
      <v-data-table
        :headers="headers"
        :items="gebruikers"
        :items-per-page="5"
        disable-pagination
        class="elevation-1"
        hide-default-footer
        @click:row="editUser"
      >
        <template v-slot:[`item.LastLogin`]="{ item }">
          <span v-if="item.LastLogin">{{
            $dayjs(item.LastLogin).format("YYYY-MM-DD HH:mm")
          }}</span>
        </template>
        <template v-slot:[`item.Active`]="{ item }">
          <span v-if="item.Active">Ja</span><span v-if="!item.Active">Nee</span>
        </template>
        <template v-slot:[`item.FotoAanwezig`]="{ item }">
          <span v-if="item.FotoAanwezig">Ja</span
          ><span v-if="!item.FotoAanwezig">Nee</span>
        </template>
      </v-data-table>
      <v-btn fab title="Account toevoegen" @click="initNewUser()"
        ><v-icon>mdi-account-plus</v-icon></v-btn
      >
    </div>
    <v-card v-if="gebruiker" max-width="500">
      <v-card-title
        >Account
        {{ gebruiker != null ? gebruiker.LoginName : "" }}</v-card-title
      >
      <v-card-text>
        <v-form v-model="valid" ref="form">
          <v-text-field
            label="Inlognaam"
            max-length="200"
            v-model="gebruiker.LoginName"
            :rules="[(v) => !!v || 'Inlognaam is verplicht']"
            required
          ></v-text-field>
          <v-text-field
            label="Voornaam"
            max-length="50"
            v-model="gebruiker.FirstName"
          ></v-text-field>
          <v-text-field
            label="Tussenvoegsel"
            max-length="10"
            v-model="gebruiker.MiddleName"
          ></v-text-field>
          <v-text-field
            label="Achternaam"
            max-length="50"
            v-model="gebruiker.LastName"
            :rules="[(v) => !!v || 'Achternaam is verplicht']"
            required
          ></v-text-field>
          <v-text-field
            label="E-mail"
            max-length="250"
            v-model="gebruiker.Email"
            :rules="[
              (v) => !!v || 'E-mailadres is verplicht',
              (v) =>
                /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
                  v
                ) || 'E-mailadres is niet geldig.',
            ]"
            required
          ></v-text-field>
          <v-checkbox
            label="Account actief"
            v-model="gebruiker.Active"
          ></v-checkbox>
          <h2>Rollen</h2>
          <v-item-group class="mt-5 mb-6">
            <v-item v-for="(r, i) in gebruiker.Role" :key="i">
              <v-checkbox
                :label="r.Name"
                v-model="r.Checked"
                class="mt-0 mb-0 pt-0 mb-0"
                dense
                hide-details
              ></v-checkbox>
            </v-item>
          </v-item-group>
          <v-img
            :src="foto"
            v-if="foto"
            max-height="100"
            max-width="200"
            class="mb-5"
            ><v-btn fab small elevation="2" right @click="foto = null">
              <v-icon title="Foto verwijderen" v-if="foto"
                >mdi-delete</v-icon
              ></v-btn
            ></v-img
          >
          <v-icon x-large class="mb-5" title="Geen foto" v-if="!foto"
            >mdi-account-off-outline</v-icon
          >
          <v-file-input
            accept="image/*"
            label="Foto uploaden"
            outlined
            prepend-icon="mdi-account-outline"
            v-model="fileinputbinary"
            messages="Vinnie gaat uit van afmeting van 1000x667. Zorg in ieder geval dat foto landscape is en verhouding 1,5:1"
          ></v-file-input>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Datum account aangemaakt</v-list-item-title>
                <v-list-item-subtitle>{{
                  gebruiker.DateInserted
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Datum laatst ingelogd</v-list-item-title>
                <v-list-item-subtitle>{{
                  gebruiker.DateLastLogin
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-form>
        <v-snackbar v-model="error.show" top light elevation="0">
          <v-alert outlined type="error" text>{{ error.message }}</v-alert>
        </v-snackbar>
        <v-snackbar v-model="info.show" top light elevation="0">
          <v-alert outlined type="info" text>{{ info.message }}</v-alert>
        </v-snackbar>
      </v-card-text>
      <v-card-actions>
        <v-btn text v-show="gebruiker && gebruiker.Id > 0" @click="reset"
          >Reset wachtwoord</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="cancel" @click="gebruiker = null">Annuleren</v-btn>
        <v-btn color="primary" @click="saveUser">Opslaan</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "PasswordReset",
  data: function () {
    return {
      headers: [
        {
          text: "Naam",
          value: "FullName",
          align: "start",
        },
        {
          text: "Accountnaam",
          value: "LoginName",
          align: "start",
        },
        {
          text: "Rol(len)",
          value: "Roles",
          align: "start",
        },
        {
          text: "Actief",
          value: "Active",
          align: "start",
        },
        {
          text: "E-mail",
          value: "Email",
          align: "start",
        },
        {
          text: "Laatste login",
          value: "LastLogin",
          align: "start",
        },
        {
          text: "Foto aanwezig",
          value: "FotoAanwezig",
          align: "start",
        },
      ],
      gebruikers: [],
      gebruiker: null,
      valid: true,
      error: { show: false, message: "" },
      info: { show: false, message: "" },
      foto: null,
      fileinputbinary: null,
    };
  },
  methods: {
    loaddata: function () {
      this.$api.UserGetList().then((response) => {
        this.gebruikers = response.data;
      });
    },
    initNewUser: function () {
      this.$api.UserInitNew().then((response) => {
        this.gebruiker = response.data[0];
        this.foto = null;
      });
      this.fileinputbinary = null;
    },
    editUser: function (u) {
      this.$api.UserGetDetails({ UserId: u.Id }).then((response) => {
        this.gebruiker = response.data[0];
      });
      this.$api.pMedewerkerFotoGet({ UserId: u.Id }).then((response) => {
        if (response.data.length > 0) this.foto = response.data[0].Foto;
        else this.foto = null;
      });
      this.fileinputbinary = null;
    },
    async saveUser() {
      let isnewuser = this.gebruiker.Id == 0;
      // Valideren
      if (this.$refs.form.validate()) {
        var validatieresp = await this.$api.UserValidate({
          json: JSON.stringify(this.gebruiker),
        });
        if (validatieresp.data[0].Success) {
          // User en foto opslaan
          const saveresp = await this.$api.UserSave({
            json: JSON.stringify(this.gebruiker),
          });
          if (isnewuser)
            this.gebruiker.Id = saveresp.data[0].UserId;
          await this.$api.pMedewerkerFotoSave({
            UserId: this.gebruiker.Id,
            Foto: this.foto,
          });
          // Stuur nieuwe gebruiker een mail voor aanmaken wachtwoord.
          if (isnewuser) {
            this.$api.NewUserMail({
              LoginId: this.gebruiker.Id,
              Email: this.gebruiker.Email,
            });
          }

          this.gebruiker = null;
          this.loaddata();
        } else {
          this.error.message = validatieresp.data[0].Msg;
          this.error.show = true;
        }
      }
    },
    reset: function () {
      if (this.$refs.form.validate()) {
        this.$api
          .UserValidate({ json: JSON.stringify(this.gebruiker) })
          .then((response) => {
            if (response.data[0].Success) {
              this.$api
                .RequestPasswordReset({ Email: this.gebruiker.Email })
                .then((response) => {
                  if (response.data == "Ok") {
                    this.info.message =
                      "Mail voor instellen wachtwoord is verzonden.";
                    this.info.show = true;
                  } else {
                    this.error.message = response.data;
                    this.error.show = true;
                  }
                })
                .catch(() => {
                  this.error.message = "Herstel wachtwoord mislukt.";
                  this.error.show = true;
                });
            } else {
              this.error.message = response.data[0].Msg;
              this.error.show = true;
            }
          });
      }
    },
  },
  watch: {
    fileinputbinary: function () {
      var reader = new FileReader();
      reader.readAsDataURL(this.fileinputbinary);
      reader.onload = () => {
        this.foto = reader.result;
      };
    },
  },
  async created() {
    this.loaddata();
  },
};
</script>

<style scoped></style>
